<section class="card bg-base-100 border border-base-300 shadow">
  <div class="card-body">
    <div class="flex w-full flex-wrap justify-between items-center gap-4">
      <h3 class="card-title text-base">
        <span class="icon-[mdi--login-variant] text-xl text-info"></span>
        유입 페이지 Top 10
      </h3>
      <div class="flex flex-wrap gap-2 items-center">
        <div class="flex items-center gap-1.5">
          <lepi-date-range
            [(startAt)]="startAt"
            [(endAt)]="endAt"
            (startAtChange)="handleDateChange()"
            (endAtChange)="handleDateChange()" />
          @if (startAt() || endAt()) {
            <button (click)="handleReset()" class="btn btn-ghost btn-sm btn-square tooltip" data-tip="기간 초기화">
              <span class="icon-[mdi--refresh] text-lg text-base-content/60"></span>
            </button>
          }
        </div>
      </div>
    </div>
    <lepi-chart [options]="options()" />
  </div>
</section>
